export const trailer = {
    HAS_TRAILER: 'HAS_TRAILER',
    NO_TRAILER: 'NO_TRAILER',
};
